import React from "react";
import style from "../Sidebar/sidebar.module.css";
import { Link } from "react-router-dom";

const Sidebar = () => {
  return (
    <>
      <div className={style.main}>
        <div className={style.txt}>
          <Link to="/">
            {" "}
            <p className="text-[#1A3168]">
              <span className="text-[#FFF856]">ED</span>flix.
            </p>
          </Link>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
